import api from "./api";

export default class MeetingMemberApi {
  static async getMeetingMember(data) {
    return await api.get(`meeting-member`, data);
  }

  static async postMeetingMemberRefund(id) {
    return await api.post(`meeting-member/refund/${id}`);
  }
}
